import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonIt from './locales/it/common.json';
import commonEn from './locales/en/common.json';
import onboardingIt from './locales/it/onboarding.json';
import onboardingEn from './locales/en/onboarding.json';
import patientIt from './locales/it/patient.json';
import patientEn from './locales/en/patient.json';
import doctorIt from './locales/it/doctor.json';
import doctorEn from './locales/en/doctor.json';
import superadminIt from './locales/it/superadmin.json';
import superadminEn from './locales/en/superadmin.json';
import hrIt from './locales/it/hr.json';
import hrEn from './locales/en/hr.json';
import careCoordinatorIt from './locales/it/careCoordinator.json';
import careCoordinatorEn from './locales/en/careCoordinator.json';
import filtersIt from './locales/it/filters.json';
import filtersEn from './locales/en/filters.json';
import modalsIt from './locales/it/modals.json';
import modalsEn from './locales/en/modals.json';
import componentsIt from './locales/it/components.json';
import componentsEn from './locales/en/components.json';
import toastsIt from './locales/it/toasts.json';
import toastsEn from './locales/en/toasts.json';
import validatorsIt from './locales/it/validators.json';
import validatorsEn from './locales/en/validators.json';

const resources = {
  it: {
    common: commonIt,
    onboarding: onboardingIt,
    patient: patientIt,
    doctor: doctorIt,
    superadmin: superadminIt,
    hr: hrIt,
    careCoordinator: careCoordinatorIt,
    filters: filtersIt,
    modals: modalsIt,
    components: componentsIt,
    toasts: toastsIt,
    validators: validatorsIt,
  },
  en: {
    common: commonEn,
    onboarding: onboardingEn,
    patient: patientEn,
    doctor: doctorEn,
    superadmin: superadminEn,
    hr: hrEn,
    careCoordinator: careCoordinatorEn,
    filters: filtersEn,
    modals: modalsEn,
    components: componentsEn,
    toasts: toastsEn,
    validators: validatorsEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    defaultNS: 'common',
    ns: ['common', 'onboarding', 'patient', 'doctor', 'superadmin', 'hr', 'careCoordinator', 'filters', 'modals', 'components', 'toasts', 'validators'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
